<template>
  <div>
    <breadcrumb v-bind:path2="path2"></breadcrumb>
    <div class="addresses">
      <div class="main-content">
        <div class="page-width">
          <div class="section-header text-center">
            <h1>{{ $t('yourAddress') }}</h1>
            <p>
              <router-link to="account">{{ $t('returnAccountDetail') }}</router-link>
            </p>
            <p>
              <el-button class="btn" @click="openAddForm">{{ $t('addNewAddress') }}</el-button>
            </p>
          </div>
          <!--address book-->
          <div v-show="addressBook===true" class="address text-center">
            <div v-for="(item,index) in this.$store.state.addresses.customerDetails" data-index="index" :key="index">
              <!--address-->
              <p>
                <span v-if="item.IsDefault"><strong>{{ $t('default') }}</strong></span>
                <span>{{item.FirstName}} {{item.LastName}}</span>
                <span>{{item.Company}}</span>
                <span>{{item.Street}}</span>
                <span>{{item.City}} {{item.State}} {{item.zip}}</span>
                <span>{{item.Country}}</span>
                <el-button type="button" @click="openEditForm(index)" class="btn btn--small address-edit-toggle">{{ $t('edit') }}</el-button>
                <el-button type="button" @click="deleteAddress(item.CustomerDetail_id)" class="btn btn--secondary btn--small address-delete">{{ $t('delete') }}</el-button>
              </p>
              <!--end address-->
              <!--edit address-->
              <div v-show="editAddressForm.index===index && editAddressForm.open===true" class="AddressNewForm">
                <h2>{{ $t('editAddress') }}</h2>
                <el-form :label-position="labelPosition" label-width="80px" :model="formRegister">
                  <el-form-item label="First Name">
                    <el-input v-model="item.FirstName"></el-input>
                  </el-form-item>
                  <el-form-item label="Last Name">
                    <el-input v-model="item.LastName"></el-input>
                  </el-form-item>
                  <el-form-item label="Company">
                    <el-input v-model="item.AddressName"></el-input>
                  </el-form-item>
                  <el-form-item label="Address">
                    <el-input v-model="item.Street" ></el-input>
                  </el-form-item>
                  <el-form-item label="City">
                    <el-input v-model="item.City" ></el-input>
                  </el-form-item>
                  <el-form-item label="Country">
                    <el-select v-model="item.Country" placeholder="select...">
                      <el-option
                        v-for="item in CountryList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="Province">
                    <el-select v-model="item.State" placeholder="select...">
                      <el-option
                        v-for="item in ProvinceList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="Postal/Zip Code">
                    <el-input v-model="item.Zip" ></el-input>
                  </el-form-item>
                  <el-form-item label="Phone">
                    <el-input v-model="item.Telephone" ></el-input>
                  </el-form-item>
                  <el-form-item class="text-center">
                    <el-checkbox v-model="item.IsDefault" >{{ $t('setDefaultAddress') }}</el-checkbox>
                  </el-form-item>
                  <div class="text-center">
                    <el-button @click="editAddress(item, item.CustomerDetail_id)" class="btn" >{{ $t('updateAddress') }}</el-button>
                    <p class="pointer" @click="openEditForm(index)">{{ $t('cancel') }}</p>
                  </div>
                </el-form>
              </div>
              <!--end edit address-->
            </div>
          </div>
          <!--end address book-->
          <!--add new address-->
          <div v-show="addAddressForm===true" class="AddressNewForm">
            <h2>{{ $t('addNewAddress') }}</h2>
            <el-form :label-position="labelPosition" label-width="80px" :model="formRegister">
              <el-form-item label="First Name">
                <el-input v-model="formRegister.FirstName"></el-input>
              </el-form-item>
              <el-form-item label="Last Name">
                <el-input v-model="formRegister.LastName"></el-input>
              </el-form-item>
              <el-form-item label="Company">
                <el-input v-model="formRegister.AddressName"></el-input>
              </el-form-item>
              <el-form-item label="Address">
                <el-input v-model="formRegister.Street" ></el-input>
              </el-form-item>
              <el-form-item label="City">
                <el-input v-model="formRegister.City" ></el-input>
              </el-form-item>
              <el-form-item label="Country">
                <el-select v-model="formRegister.Country" placeholder="请选择">
                  <el-option
                    v-for="item in CountryList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Province">
                <el-select v-model="formRegister.State" placeholder="请选择">
                  <el-option
                    v-for="item in ProvinceList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Postal/Zip Code">
                <el-input v-model="formRegister.Zip" ></el-input>
              </el-form-item>
              <el-form-item label="Phone">
                <el-input v-model="formRegister.Telephone" ></el-input>
              </el-form-item>
              <el-form-item class="text-center">
                <el-checkbox v-model="formRegister.IsDefault" >{{ $t('setDefaultAddress') }}</el-checkbox>
              </el-form-item>
              <div class="text-center">
                <el-button @click="postAddress(formRegister)" class="btn" >{{ $t('addNewAddress') }}</el-button>
                <p class="pointer" @click="openAddForm"> {{ $t('cancel') }}</p>
              </div>
            </el-form>
          </div>
          <!--end add new address-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import breadcrumb from '../components/breadcrumb'
import { validateZipCode, validatePhoneNumber } from "../../config/validation";

export default {
  name: "addresses",
  components: {
    breadcrumb,
  },
  data() {
    return {
      path2: this.$t('addresses'),
      errors: [],
      labelPosition: 'top',//表格排列方式
      formRegister: {
        AddressName: '', //Company 
        City: '',
        Country: '',
        CustomerDetailId: '', //CustomerDetail_id is the id for api
        CustomerId: '', //Customer_id
        Email: '',
        FirstName: '',
        IsDefault: false,
        LastName: '',
        State: '',
        Street: '',
        Telephone: '',
        Zip: '',
      },
      editAddressForm: {
        index: '',
        open: false,
      },
      addressBook: true,
      addAddressForm: false,
      ProvinceList: this.$store.state.addresses.states, //States drop down data
      CountryList:[{
        value: '',
        label: '---'
      }, {
        value: 'United States',
        label: 'United States'
      }], //Country drop down data
    }
  },
  computed: {
  },
  methods:{
    ...mapActions(
      'addresses',
      ['fetchAddresses', 'postAddress', 'editAddress', 'deleteAddress'],
    ),
    openEditForm(index){
      this.editAddressForm.index = index;
      this.editAddressForm.open = !this.editAddressForm.open;
    },
    openAddForm(){
      this.addAddressForm = !this.addAddressForm;
      this.addressBook = !this.addressBook;
      this.editAddressForm.open = false;
    },
    checkForm: async function (form) {
      this.errors = [];
      if(!form.FirstName) {
       this.errors.push('First name is required')
      };
      if(!form.LastName) {
        this.errors.push('Last name is required')
      };
      if(!form.AddressName) {
        this.errors.push('Company name is required')
      };
      if(!form.Street) {
        this.errors.push('Address is required')
      };
      if(!form.City) {
        this.errors.push('City is required')
      };
      if(!form.Country) {
        this.errors.push('Country is required')
      };
      if(!form.State) {
        this.errors.push('State is required')
      };
      if (validateZipCode(form.Zip))(
        this.errors.push('Zip code is required or has wrong format')
      );
      if (validatePhoneNumber(form.Telephone))(
        this.errors.push('Phone is required or has wrong format')
      );
    },
    postAddress(form) {
      this.checkForm(form);
      if (!this.errors.length) {
        this.$store.dispatch('addresses/postAddress', form);
      } else {
        alert(this.errors);
      }
    },
    editAddress(form, id) {
      this.checkForm(form);
      if (!this.errors.length) {
        this.$store.dispatch('addresses/editAddress', [form, id]);
      } else {
        alert(this.errors);
      }
    },
    deleteAddress(id) {
      this.$store.dispatch('addresses/deleteAddress', id);
    },
  },
  mounted() {
    this.$store.dispatch('addresses/fetchAddresses');
  },
}
</script>

<style lang="less">
@import "../assets/css/public.less";
@import "../assets/css/addresses.less";
</style>



// WEBPACK FOOTER //
// src/view/addresses.vue